import React from "react";
import { Box, Button, Chip, Stack, Typography } from "@mui/material";
import { LocalPrintshop as PrintIcon } from "@mui/icons-material";

const ManifestHeader = ({
    manifest,
    manifestId,
    onPrintManifest,
    onPrintManifestSF,
    onPrintRoadMap,
    onPrintRoadSheet10,
}) => {
    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", md: "center" }}
            flexDirection={{ xs: "column", md: "row" }}
            gap={2}
        >
            <Box>
                <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                    <Typography variant="h6" fontWeight="bold">
                        Manifiesto MN-{String(manifestId).padStart(6, "0")}
                    </Typography>

                    <Chip
                        size="small"
                        label={manifest?.manest || "-"}
                        color={
                            manifest?.manest === "COMPLETADO"
                                ? "success"
                                : manifest?.manest === "CANCELADO"
                                    ? "error"
                                    : manifest?.manest === "EN_PROCESO"
                                        ? "warning"
                                        : "info"
                        }
                        sx={{ fontWeight: "bold" }}
                    />
                </Stack>

                <Typography variant="body2" color="text.secondary">
                    {manifest?.maninf || "Detalle operativo del manifiesto"}
                </Typography>
            </Box>

            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                <Button variant="outlined" startIcon={<PrintIcon />} onClick={onPrintManifestSF}>
                    Manifiesto SF
                </Button>
                <Button variant="outlined" startIcon={<PrintIcon />} onClick={onPrintManifest}>
                    Manifiesto
                </Button>
                <Button variant="outlined" startIcon={<PrintIcon />} onClick={onPrintRoadMap}>
                    Hoja de ruta
                </Button>
                {/*<Button variant="outlined" startIcon={<PrintIcon />} onClick={onPrintRoadSheet10}>
                    Hoja 10
                </Button>*/}
            </Stack>
        </Box>
    );
};

export default ManifestHeader;